// extracted by mini-css-extract-plugin
export default {"description":"StyleTransfer_description__lLjcd","styleImages":"StyleTransfer_styleImages__AMRGL","part":"StyleTransfer_part__mqRZD"};